import { getEmailSchema } from '@diagon-alley/common';
import { useTranslate } from '@hooks/i18n';
import { Anchor, Button, Card, Stack, TextInput } from '@mantine/core';
import { type FC, useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDebouncedBusy } from '../LoginLanding';

export const InvitationPage: FC = () => {
    const { t } = useTranslate();
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [msg, setMsg] = useState<string | null>(null);
    const [err, setErr] = useState<string | null>(null);
    const { busy, start, stop } = useDebouncedBusy(400);

    const submit = useCallback(async () => {
        setErr(null);
        setMsg(null);
        const ok = getEmailSchema().safeParse(email);
        if (!ok.success)
            return setErr(
                ok.error.issues[0]?.message || t('invite.errors.email'),
            );
        start();
        // const res = await apiRequestInvitation(email);
        const res = { ok: true };
        stop();
        //@ts-ignore
        if (!res.ok) return setErr(res.error || t('invite.errors.generic'));
        setMsg(t('invite.sent'));
    }, [email, start, stop, t]);

    return (
        <Stack align="center" p="xl" justify="center" className="h-[100vh]">
            <Card withBorder radius="xl" p="lg" className="w-[380px]">
                <Stack>
                    {msg && (
                        <div className="rounded-md border border-green-200 bg-green-50 p-2 text-sm text-green-700">
                            {msg}
                        </div>
                    )}
                    {err && (
                        <div className="rounded-md border border-red-200 bg-red-50 p-2 text-sm text-red-700">
                            {err}
                        </div>
                    )}

                    <TextInput
                        label={t('invite.emailLabel')}
                        placeholder={t('invite.emailPlaceholder')}
                        value={email}
                        onChange={(e) => setEmail(e.currentTarget.value)}
                        autoComplete="email"
                    />
                    <Button radius="xl" onClick={submit} loading={busy}>
                        {t('invite.request')}
                    </Button>
                    <Anchor
                        onClick={() => nav('/login')}
                        size="sm"
                        className="cursor-pointer"
                    >
                        {t('invite.backToLogin')}
                    </Anchor>
                </Stack>
            </Card>
        </Stack>
    );
};
